import React from 'react';
import { Image  } from 'semantic-ui-react';
import Assets from 'mpm-assets';


const MPMLoader = (props) => {
    return (
    
            <div className={props.content === undefined ? 'mpm-loader cusloading' : 'mpm-loader cusloading content'}>
                {
                        !props.hideLogo && <div className="mpm-loader-img">
                        <Image src={Assets.Images.logo_mpm_big} as='img' size='medium' />
                </div>
                }
               {
                       !props.hideDots &&  <div className="loading-dots">
                       <div className="loading-dots--dot"></div>
                       <div className="loading-dots--dot"></div>
                       <div className="loading-dots--dot"></div>
               </div>
               }
                <div className="mpm-loader-txt">
                        {props.message ? props.message : null}
                </div>
        </div>
    
    
    );
} 

export default MPMLoader;